import { render, staticRenderFns } from "./CreateTeam.vue?vue&type=template&id=289c109c"
import script from "./CreateTeam.vue?vue&type=script&lang=js"
export * from "./CreateTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports